/**
 * 笔记API函数
 * 提供笔记相关功能，如保存笔记、获取笔记等
 */
import { supabase } from '../supabaseClient';

/**
 * 保存笔记
 * @param {string} userId - 用户ID
 * @param {string} questionId - 题目ID
 * @param {string} content - 笔记内容
 * @returns {Promise<Object>} 保存结果
 */
export const saveNote = async (userId, questionId, content) => {
  try {
    if (!userId) throw new Error('用户ID不能为空');
    if (!questionId) throw new Error('题目ID不能为空');
    if (!content) throw new Error('笔记内容不能为空');
    
    const { data, error } = await supabase
      .from('notes')
      .insert([
        {
          _id: `${Date.now()}_${Math.random().toString().substring(2, 10)}`,
          user_id: userId,
          textContent: content,
          msgType: 'text',
          sendTime: {
            $date: new Date().toISOString()
          },
          sendTimeTS: Math.floor(Date.now() / 1000),
          groupId: questionId // 使用问题ID作为分组
        }
      ]);
      
    if (error) throw error;
    
    return { success: true, data };
  } catch (error) {
    console.error('保存笔记出错:', error);
    return { success: false, error: error.message };
  }
};

/**
 * 获取题目的笔记列表
 * @param {string} userId - 用户ID
 * @param {string} questionId - 题目ID
 * @returns {Promise<Array>} 笔记列表
 */
export const getNotesByQuestion = async (userId, questionId) => {
  try {
    if (!userId) throw new Error('用户ID不能为空');
    if (!questionId) throw new Error('题目ID不能为空');
    
    const { data, error } = await supabase
      .from('notes')
      .select('*')
      .eq('user_id', userId)
      .eq('groupId', questionId)
      .order('sendTimeTS', { ascending: false });
      
    if (error) throw error;
    
    return data || [];
  } catch (error) {
    console.error('获取笔记列表出错:', error);
    return [];
  }
};

/**
 * 删除笔记
 * @param {string} userId - 用户ID
 * @param {string} noteId - 笔记ID
 * @returns {Promise<Object>} 删除结果
 */
export const deleteNote = async (userId, noteId) => {
  try {
    if (!userId) throw new Error('用户ID不能为空');
    if (!noteId) throw new Error('笔记ID不能为空');
    
    const { error } = await supabase
      .from('notes')
      .delete()
      .eq('_id', noteId)
      .eq('user_id', userId);
      
    if (error) throw error;
    
    return { success: true };
  } catch (error) {
    console.error('删除笔记出错:', error);
    return { success: false, error: error.message };
  }
};

/**
 * 获取用户全部笔记
 * @param {string} userId - 用户ID
 * @returns {Promise<Array>} 笔记列表
 */
export const getAllNotes = async (userId) => {
  try {
    if (!userId) throw new Error('用户ID不能为空');
    
    const { data, error } = await supabase
      .from('notes')
      .select('*')
      .eq('user_id', userId)
      .order('sendTimeTS', { ascending: false });
      
    if (error) throw error;
    
    return data || [];
  } catch (error) {
    console.error('获取全部笔记出错:', error);
    return [];
  }
}; 